import React from "react";
import StarRatings from "react-star-ratings";

// Style
import { RatingStyled } from "../style";
import Color from "../../../assets/color";

const Rating = props => {
  return (
    <RatingStyled>
      <div className="d-flex align-items-center">
        <StarRatings
          rating={parseInt(props.rating)}
          starRatedColor={Color.primary}
          starEmptyColor={Color.mercury}
          starDimension="15px"
          starSpacing="1px"
        />
        <div className="rating-container">
          <span>
            <span className="total_rating">{props.rating}</span>/5
          </span>
          <span className="total_vote">({props.total_vote})</span>
        </div>
      </div>
    </RatingStyled>
  );
};

export default Rating;
